/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type IntegrationEntry = {
  packageId: string;
  packageImageAssetId?: string | undefined;
  packageKeywords?: Array<string> | undefined;
  packageName: string;
  packageSummary?: string | undefined;
  packageTitle?: string | undefined;
  packageUrl?: string | undefined;
  toolNames: Array<string>;
  version: string;
  versionCreatedAt: Date;
};

/** @internal */
export const IntegrationEntry$inboundSchema: z.ZodMiniType<
  IntegrationEntry,
  unknown
> = z.pipe(
  z.object({
    package_id: z.string(),
    package_image_asset_id: z.optional(z.string()),
    package_keywords: z.optional(z.array(z.string())),
    package_name: z.string(),
    package_summary: z.optional(z.string()),
    package_title: z.optional(z.string()),
    package_url: z.optional(z.string()),
    tool_names: z.array(z.string()),
    version: z.string(),
    version_created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "package_id": "packageId",
      "package_image_asset_id": "packageImageAssetId",
      "package_keywords": "packageKeywords",
      "package_name": "packageName",
      "package_summary": "packageSummary",
      "package_title": "packageTitle",
      "package_url": "packageUrl",
      "tool_names": "toolNames",
      "version_created_at": "versionCreatedAt",
    });
  }),
);

export function integrationEntryFromJSON(
  jsonString: string,
): SafeParseResult<IntegrationEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IntegrationEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IntegrationEntry' from JSON`,
  );
}
